/* tslint:disable */

declare var Object: any;
export interface BuilderServiceInterface {
  "id"?: number;
}

export class BuilderService implements BuilderServiceInterface {
  "id": number;
  constructor(data?: BuilderServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `BuilderService`.
   */
  public static getModelName() {
    return "BuilderService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of BuilderService for dynamic purposes.
  **/
  public static factory(data: BuilderServiceInterface): BuilderService{
    return new BuilderService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'BuilderService',
      plural: 'BuilderServices',
      path: 'BuilderServices',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/BuilderService.ts